import { React, useEffect, useState } from "react";
import ico_handy_orange from "../../../assets/icons/ico_handy_orange.svg";
import ico_huellas_green from "../../../assets/icons/ico_huellas_green.svg";
import ToolsInfoSection from "../../../components/toolsInfoSection";
import ToolsTab from "../../../components/toolsTab";
import VideoBanner from "../../../components/videoBanner";
import img_ballena_app from "../../../assets/images/img_ballena_app.png";
import ico_ballenas from "../../../assets/icons/ico_ballenas.svg";
import GoToPage from "../../../components/goToPage";
import ToolsActivityButton from "../../../components/toolsActivityButton";
const WhalesAppScreen = ({ handle }) => {
  const oceano = "MsNqF-Xjc44";
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    handle(false);
    return () => handle(true);
  }, [handle]);

  return (
    <div className="w-full bg-[#002E0F] h-full overflow-hidden">
      {width > 1279 ? (
      <div>
<div className="w-full lg:h-[1080px]  absolute">
        <VideoBanner idVideo={oceano}></VideoBanner>
      </div>
      <div className="w-full mx-auto text-white relative h-fit  ">
        <div className="absolute right-0 mt-[30rem] mb-10">
          <img
          
            src={img_ballena_app}
            className="lg:w-[60rem] md:w-[20rem] sm:w-[20rem] w-[20rem] 2xl:visible xl:invisible lg:invisible md:invisible sm:visible visible"
          ></img>
        </div>

        <div className="justify-center text-black h-fit text-left pt-[14rem] relative lg:pl-[8rem] md:pl-[3rem] sm:pl-[3rem] pl-[3rem]">
         <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
        </div>
        <div className="grid mb-52 relative lg:pl-32 md:pl-20 sm:pl-10 pl-10 2xl:pr-0 xl:pr-[15rem] lg:pr-[20rem] md:pr-[5rem] sm:pr-[5rem] pr-[5rem] mr-80 2xl:grid-cols-5 xl:grid-cols-1 lg:grid:cols-1 md:grid-cols-1 sm:grid-cols-1 grid-cols-1 2xl:pb-[10rem] xl:pb-[70rem] lg:pb-[70rem] md:pb-[90rem] sm:pb-[90rem] pb-[90rem] min-w-[10rem] pt-10 w-full  ">
              <div className="xl:h-[70rem] col-span-2 lg:h-[75rem] md:h-[75rem] sm:h-full h-full text-black lg:mr-10 bg-white w-full z-10 relative   ">
            <ToolsInfoSection
              firstIcon={ico_handy_orange}
              secondIcon={ico_huellas_green}
              tag="Ballenas"
              title={
                <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                  App de ballenas
                </h1>
              }
              text={
                <div>
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                    <b>Samaná Whale Reporter</b> es una aplicación móvil de
                    ciencia ciudadana que permite el monitoreo y reporte
                    de avistamientos
                   de ballenas.
                  </p>
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                   Las <b>ballenas jorobadas</b> presentan un patrón de coloración en la parte ventral de la aleta caudal que va de completamente blanco a completamente negro y presenta cicatrices, líneas, manchas y hendiduras que, en conjunto con su borde, forma y tamaño de la hendidura central, proveen una característica distintiva para cada individuo adulto (Katona y Whitehead, 1981). Esta característica permite distinguir a un individuo de otro, de la misma forma que se hace con las huellas dactilares.
                  </p>
                </div>
              }
            ></ToolsInfoSection>

          </div>
         <div className="relative col-span-3 2xl:mt-[11rem] xl:mt-[0rem] lg:mt-[0rem] md:mt-[0rem] sm:mt-[0rem] mt-[0rem]  items-center">
                <div className=" grid relative gap-0">
                  <div className="h-full relative">
             
                <div className="h-44 w-full bg-[#F77E0B] relative 2xl:mt-[25.6rem] xl:mt-0 md:mt-0 sm:mt-0 mt-0 pl-20">
                  <div className="relative text-white inline-flex">
                    <div className="inline-flex items-center py-5 ml-10 mr-10">
                      <img loading="lazy" src={ico_ballenas}></img>
                      <label className="ml-5 text-2xl font-bold">
                        Ballenas
                      </label>
                    </div>
                    <p className="text-lg pt-5 pb-5 px-20 ">
                    Las ballenas jorobadas (Megaptera novaeangliae) del Atlántico Norte Occidental, migran cada invierno desde sus áreas de alimentación en las aguas costeras frías hasta las aguas cálidas del Atlántico Occidental Tropical y el Caribe insular.
                    </p>
                  </div>
                </div>
              </div>
              <div className="relative w-full h-full items-center  text-white bg-[#002E0F] pr-10 pt-5">
                <ToolsTab
                 firstTitle="La Bahía de Samaná en República Dominicanaa"
                 secondTitle="Resultados y beneficios"
                  firstTab={
                    <p className="text-xl">
                      {" "}
                      La Bahía de Samaná es uno de los sitios que visitan
                      anualmente las ballenas jorobadas y ha dado lugar a una de
                      las actividades turísticas de observación más atractivas
                      del mundo. De hecho, esta bahía tiene el privilegio de ser
                      conocida a nivel internacional como uno de los mejores
                      lugares para la observación de la especie.
                    </p>
                  }
                  secondTab={
                    <div>
                      <p className="text-xl mb-5">
                        La app permite el seguimiento de la población de
                        ballenas a nivel de individuo.
                      </p>
                      <p className="text-xl mb-5">
                        A partir de esta app se creará una base de datos para
                        CEBSE que permitirá la protección de la especie y su
                        hábitat.
                      </p>
                      <p className="text-xl mb-5">
                        La información permite conocer aspectos sobre la
                        biología y la dinámica de su población, entre ellos, sus
                        rutas migratorias, tamaño, estructura social,
                        comportamiento, longevidad y tasas reproductivas.
                      </p>
                    </div>
                  }
                ></ToolsTab>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      ):(
      <div>
<div className="w-full absolute ">
            <VideoBanner idVideo={oceano}></VideoBanner>
            <div className=" absolute right-0 bottom-0 lg:mb-40 md:mb-32 sm:mb-[4rem] mb-[4rem] lg:mr-32 md:mr-20 sm:mr-10 mr-10">
              <img
              
                src={img_ballena_app}
                className="lg:w-[35rem] md:w-[25rem] sm:w-[15rem] w-[15rem]"
              ></img>
            </div>
          </div>

          <div className="grid grid-cols-1  2xl:px-52  lg:px-30 md:px-10 sm:px-14 px-10 pb-[40rem]">
            <div className="justify-center text-black h-fit text-left lg:mt-[25rem] md:mt-[15rem] sm:mt-[7rem] mt-[7rem] relative ">
             <GoToPage
                page="/herramientas"
                side="left"
                name="Atrás"
                fontSizeXL="xl:text-xl"
                fontSizeL="lg:text-lg"
                fontSizeM="md:text-lg"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-5"
                iconColor="invert"
                iconMargin="mr-5"
              ></GoToPage>
            </div>

            <div className=" h-fit text-black  bg-white w-full z-10 relative bottom-0  mt-[4rem]  ">
              <div className="lg:h-44 md:h-40 sm:h-32 h-32 w-full bg-[#F77E0B] relative">
                <div className="grid grid-cols-2 grid-rows-1 relative text-white   ">
                  <div className=" inline-flex justify-center w-full absolute lg:py-5 md:py-5 sm:py-2 py-2 lg:px-10 md:px-5 sm:px-5 px-5">
                    <div className="w-fit  mr-2">
                    <img
                    
                        src={ico_ballenas}
                        className="lg:w-20 md:w-14 sm:w-14 w-14"
                      ></img>
                      </div>
                    <div className="">
                    <div className="inline-flex items-center  ">
                     
                      <label className=" lg:text-2xl md:text-xl sm:text-lg text-lg font-bold">
                        Macroinvertebrados
                      </label>
                    </div>
                    <div className=" w-full">
                      <p className="lg:text-lg md:text-base sm:text-xs text-xs">
                        Este grupo está compuesto por animales de {" "}
                        distintos grupos taxonómicos, incluyendo {" "}
                        insectos, arañas, cangrejos, conchas y  camarones,
                        entre otros.
                      </p>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
              <ToolsInfoSection
              firstIcon={ico_handy_orange}
              secondIcon={ico_huellas_green}
              tag="Ballenas"
              title={
                <h1 className="lg:text-5xl md:text-2xl sm:text-2xl text-2xl lg:px-10 md:px-0 sm:px-0 px-0 lg:text-left md:text-center sm:text-center text-center font-bold  my-10 ">
                  App de ballenas
                </h1>
              }
              text={
                <div>
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base pb-5">
                    <b>Samaná Whale Reporter</b> es una aplicación móvil de
                    ciencia ciudadana que permite el monitoreo y reporte
                    de avistamientos
                   de ballenas.
                  </p>
                  <p className="lg:px-10 md:px-0 sm:px-0 px-0 lg:text-xl md:text-xl sm:text-base text-base ld:pb-44 md:pb-40 sm:pb-32 pb-32">
                  Las <b>ballenas jorobadas</b> presentan un patrón de coloración en la parte ventral de la aleta caudal que va de completamente blanco a completamente negro y presenta cicatrices, líneas, manchas y hendiduras que, en conjunto con su borde, forma y tamaño de la hendidura central, proveen una característica distintiva para cada individuo adulto (Katona y Whitehead, 1981). Esta característica permite distinguir a un individuo de otro, de la misma forma que se hace con las huellas dactilares.

                  </p>
                </div>
              }
            ></ToolsInfoSection>

            </div>
            <div className="relative w-full h-full items-center lg:mt-32 md:mt-10 sm:mt-5 mt-5  text-white bg-[#002E0F]">
            <ToolsTab
            firstTitle="La Bahía de Samaná en República Dominicana"
            secondTitle="Resultados y beneficios"
                  firstTab={
                    <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                      {" "}
                      La Bahía de Samaná es uno de los sitios que visitan
                      anualmente las ballenas jorobadas y ha dado lugar a una de
                      las actividades turísticas de observación más atractivas
                      del mundo. De hecho, esta bahía tiene el privilegio de ser
                      conocida a nivel internacional como uno de los mejores
                      lugares para la observación de la especie.
                    </p>
                  }
                  secondTab={
                    <div>
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                        La app permite el seguimiento de la población de
                        ballenas a nivel de individuo.
                      </p>
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                        A partir de esta app se creará una base de datos para
                        CEBSE que permitirá la protección de la especie y su
                        hábitat.
                      </p>
                      <p className="lg:text-xl md:text-base sm:text-sm text-sm mb-5">
                        La información permite conocer aspectos sobre la
                        biología y la dinámica de su población, entre ellos, sus
                        rutas migratorias, tamaño, estructura social,
                        comportamiento, longevidad y tasas reproductivas.
                      </p>
                    </div>
                  }
                ></ToolsTab>
            </div>
          </div>

      </div>
      )}
      
    </div>
  );
};

export default WhalesAppScreen;
